module.exports = __webpack_public_path__ + "static/daramola-d4e5546254e57aacd6053464ea7ee0ea.jpg";